export class AppConfiguration {
  API_BASE_URL: string;
  ACCESS_BASE_URL: string;
  TIMELINE_API_BASE_URL: string;
  WORKFLOW_API_BASE_URL: string;
  NOTIFICATION_API_BASE_URL: string;
  REACTION_API_BASE_URL: string;
  COMMENTS_API_BASE_URL: string;
  STORAGE_BASE_URL: string;
  LOGS_API_BASE_URL: string;
  FUNCTIONS_API_BASE_URL: string;
  QR_CODE_API_URL: string;
  AUTHORITY: string;
  SCOPE: string;
  CLIENT_ID: string;
  MAX_ID_TOKEN_IAT_OFFSET_ALLOWED_IN_SECONDS: number;
  SYSTEM_ClIENT_ID: string;
  SYSTEM_ClIENT_SECRET: string;
  APP_URL: string;
  IS_HEADLESS_BROWSER: boolean;
  OSOS_AI_URL: string;
  IS_OSOS_AI_ENABLED: boolean;
  AUTO_REDIRECT: boolean;
  DEFAULT_LANGUAGE: string;
  AGORA_APP_ID: string;
  RTC_APP_ENABLED: boolean;
  SOCKET_BASE_URL: string;
  SOCKET_DEBOUNCE_TIME: number;
  REQUEST_QUEUE: {
    ENABLED: boolean;
    MAX_RETRIES: number;
    RETRY_DELAY: number;
  };
}
